// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"152":"b0b8a1d1","643":"50e02b98","972":"58e04398"}[chunkId] + ".chunk.css";
};